<template>
    <div>
        <multiselect v-model="nTemplateID" label="text" track-by="id" :options="templates" :searchable="false"
            :show-labels="false" openDirection="below">
        </multiselect>
        <hr>
        <div v-show="templateID === 1" class="custom-control custom-switch">
            <input type="checkbox" class="custom-control-input" id="showCredits" v-model="nShowCredits">
            <label class="custom-control-label" for="showCredits">{{ $t('label.show_credits') }}</label>
        </div>
        <br>
        <div v-show="templateID === 1" class="custom-control custom-switch">
            <input type="checkbox" class="custom-control-input" id="showPoints" v-model="nShowPoints">
            <label class="custom-control-label" for="showPoints">{{ $t('label.show_points') }}</label>
        </div>
        <br>
        <div v-show="templateID === 1" class="custom-control custom-switch">
            <input type="checkbox" class="custom-control-input" id="showOutstandings" v-model="nShowOutstandings">
            <label class="custom-control-label" for="showOutstandings">{{ $t('label.show_outstandings') }}</label>
        </div>
    </div>
</template>

<script>
import { nextTick } from 'vue'

export default {
    name: 'receiptTemplate',
    props: {
        templateID: { type: Number },
        showCredits: { type: Number },
        showPoints: { type: Number },
        showOutstandings: { type: Number }
    },
    data() {
        return {
            templates: [{ id: 0, text: 'Classic' }, { id: 1, text: 'Modern' }],
        }
    },
    computed: {
        nTemplateID: {
            get() { return this.templates.find(k => k.id === this.templateID) },
            set(value) {
                this.$emit('update', 'templateID', value['id'])
                this.$emit('update', 'templeteID', value['id'])
            }
        },
        nShowCredits: {
            get() { return this.showCredits === 1 ? true : false; },
            set(value) { this.$emit('update', 'showCredits', value ? 1 : 0) }
        },
        nShowPoints: {
            get() { return this.showPoints === 1 ? true : false; },
            set(value) { this.$emit('update', 'showPoints', value ? 1 : 0) }
        },
        nShowOutstandings: {
            get() { return this.showOutstandings === 1 ? true : false; },
            set(value) { this.$emit('update', 'showOutstandings', value ? 1 : 0) }
        },
    },
    methods: {
    }
}
</script>